<template>
  <q-select
    v-model="customers"
    outlined
    :options="filterOptions"
    :loading="isLoading"
    use-input
    dense
    emit-value
    map-options
    v-bind="!customers && { placeholder: '選択してください' }"
    @update:model-value="(value:string) => selected(value)"
    @filter="filterFn"
  >
    <template #no-option>
      <q-item>
        <q-item-section class="text-grey">該当する得意先はありません</q-item-section>
      </q-item>
    </template>
  </q-select>
</template>
<script setup lang="ts">
import axios from 'axios';
import { computed, ref } from 'vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import router from '../../router';

interface Props {
  customer?: string | null;
}
const props = defineProps<Props>();
const customers = ref(computed(() => props.customer));
// Loading
const isLoading = ref(false);

interface CustomerSelect {
  label: string;
  value: string;
}
// プルダウン
const options = ref<CustomerSelect[]>([]);
// プルダウン（フィルター用）
const filterOptions = ref(options.value);

const emit = defineEmits<{
  (event: 'selected', customer: string): void;
}>();
const selected = (customer: string) => {
  emit('selected', customer);
};

/**
 * 得意先リスト取得
 */
const getCustmer = () => {
  // Loading Start
  isLoading.value = true;

  axios
    .post('/customers')
    .then((res) => {
      const { common, customerSelectItems } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          customerSelectItems.forEach(
            (customer: { customer_code: string; customer_name: string }) => {
              options.value.push({
                label: `${customer.customer_code}: ${customer.customer_name}`,
                value: customer.customer_code,
              });
            }
          );
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      isLoading.value = false;
    });
};

// プルダウンフィルター
const filterFn = (val: string, update: (arg0: () => void) => void) => {
  update(() => {
    if (val === '') {
      filterOptions.value = options.value;
    } else {
      const needle = val.toLowerCase();
      filterOptions.value = options.value.filter(
        (v: { label: string; value: string }) =>
          v.label.toLowerCase().indexOf(needle) > -1 || v.value.toLowerCase().indexOf(needle) > -1
      );
    }
  });
};

/**
 * 初期表示処理
 */

getCustmer();
</script>
